import React, {Component} from 'react';
import Column from "@amzn/meridian/column";
import  BagTrackingContextProvider from "./context/BagTrackingContext";
import BagTracking from "./BagTracking";
import {BagTrackingBanner} from "./BagTrackingUtil"

class BagTrackingPage extends Component {
    render() {
        return (
            <Column>
                <BagTrackingBanner/>
                <BagTrackingContextProvider>
                    <BagTracking/>
                </BagTrackingContextProvider>
            </Column>
        )
    }
};

export default BagTrackingPage;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/bagtracking/BagTrackingPage.js